<template>
  <div>
    <section class="addr-hero">
      <v-row align="center" justify="center" class="ma-0">
        <v-col class="text-center" cols="12">
          <h2 class="text-h6 white--text font-weight-light mb-4">Encuéntranos en</h2>
          <p class="text-h4 white--text font-weight-medium mb-4">Av. General Mendiburu 686</p>
          <p class="text-h4 white--text font-weight-medium mb-0">Miraflores</p>
        </v-col>
      </v-row>
    </section>

    <div class="grey lighten-4">
      <v-container class="py-12" style="max-width: 1100px">
        <v-row align="center">
          <v-col cols="12" md="6" class="text-center text-md-left">
            <h2 class="text-h5 black--text font-weight-medium mb-4">Horario de atención</h2>
            <p class="text-body-1 text-no-wrap black--text font-weight-light mb-1">
              Lunes a viernes: 8:00 a.m. – 7:00 p.m.
            </p>
            <p class="text-body-1 text-no-wrap black--text font-weight-light mb-8">
              Sábados: 9:00 a.m. – 4:00 p.m.
            </p>
            <v-btn
              color="grey darken-3"
              dark
              large
              href="https://www.google.com/maps/dir/?api=1&destination=-12.1139738,-77.0460796"
              target="_blank"
              rel="noopener"
            >
              Cómo llegar
            </v-btn>
          </v-col>
          <v-col cols="12" md="6">
            <div class="map-frame">
              <iframe
                title="Ubicación de Hub Design en Google Maps"
                src="https://maps.google.com/maps?q=-12.1139738,-77.0460796&z=16&output=embed"
                width="100%"
                height="320"
                style="border: 0; display: block"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>
<script>
export default {
  name: "Encuentranos",
};
</script>
<style scoped>
.addr-hero {
  min-height: 301px;
  display: flex;
  align-items: center;
  background-image: url("../assets/IMG_3070 copia 1.webp");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.map-frame {
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
  line-height: 0;
}
</style>
